import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { createKey } from "../../../../../Shared/utils/createKey";
import { MealType_Details } from "../../MealComponents/MealType_Details";
import { ProgramDetails } from "../../ProgramComponents/ProgramDetails";
/**
 *
 * @param param0
 * @returns
 */
export const OrderDetailsAccordion_DetailsContent = ({ programName, programId, mappedMeals, subscriptionLinkId, orderTotal, showPriceIfZero, skipPayments, orderType, orderTypeDetails, orderIsSkipped, skippedOrderText, showSubscriptionLinkId, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(Grid, Object.assign({ item: true, xx: 12, sm: 9 }, { children: _jsxs(Grid, Object.assign({ xx: 12, container: true, item: true, spacing: 2 }, { children: [_jsx(ProgramDetails, Object.assign({}, {
                    programName,
                    programId,
                    subscriptionLinkId,
                    orderTotal,
                    showPriceIfZero,
                    skipPayments,
                    orderType,
                    orderTypeDetails,
                    showSubscriptionLinkId,
                })), orderIsSkipped && skippedOrderText && (_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Typography, { children: skippedOrderText }) }))), mappedMeals === null || mappedMeals === void 0 ? void 0 : mappedMeals.map((mappedMeal) => (_jsx(Grid, Object.assign({ id: mappedMeal.day, item: true, xx: 12, mb: 2 }, { children: _jsx(MealType_Details, { mappedMeal: mappedMeal }) }), createKey())))] })) })));
};
